import 'zone.js'; // Ajout de l'import pour Zone.js
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import {CalendarEvent} from './app/flexible-calendar/calendar-event.model';
import packageJson from '../package.json';

export function string_sorter_for_column(l:string[]) : string[] {
  if(!l || l.length==0)return []
  if(typeof(l[0])!=="string")return l.sort()

  let rc : string[] = l.sort((a,b) => a.localeCompare(b))
  if(rc.join(",")==="Je,Lu,Ma,Me,Ve"){
    rc=["Lu","Ma","Me","Je","Ve"]
  }
  return rc
}


export function translate_to_dict(l:any[],field:string="code"){
  let rc:any={}
  for(let item of l){
    if(item.hasOwnProperty(field)){
      rc[item[field]]=item
    }
  }
  return rc
}


export function getEventsForColumn(columnHeader: string,columnHeaderName:string[],events:CalendarEvent[]): CalendarEvent[] {
  return events.filter(event => {
      let i=0
      for(let colHeader of columnHeaderName){
        if(i<columnHeader.split("-").length && convert_to_find_day(event.props[colHeader]) != columnHeader.split("-")[i])return false
        i=i+1
      }
      return true
    }
  );
}

export function alert_message(vm:any,txt:string) {
  vm.toast.open(txt)
  setTimeout(()=>{vm.toast.dismiss()},1500)
}



export function shorter(txt:string | null) {
  if(txt && txt.length>20)txt=txt.slice(0,20)+"..."
  return txt;
}




export function convert_to_find_day(txt: string) {
  if(!txt)return ""

  const days=["","Lu","Ma","Me","Je","Ve","Sa","Di"]
  for(let i=1;i<=7;i++){
    txt=txt.toString().replace("#"+i,days[i])
  }

  return txt
}




export function convert_to_day(id: number) {
  const days=["","Lu","Ma","Me","Je","Ve","Sa","Di"]
  return days[id]
}




// export function getInfobullForExvent(event: CalendarEvent) {
//   const formatterStart=new Intl.DateTimeFormat('fr-FR', {
//     month: '2-digit',
//     day: '2-digit',
//     hour: '2-digit',
//     minute: "2-digit"
//   })
//   const formatterEnd=new Intl.DateTimeFormat('fr-FR', {
//     hour: '2-digit',
//     minute: "2-digit"
//   })
//   let rc=event.label+" - "+ event.salle + "\n"
//   rc=rc+formatterStart.format(event.startTime)+" -> "+formatterEnd.format(event.endTime)+"\n"
//   for(let k of Object.keys(event.props)){
//     rc=rc+"\n"+k+": "+convert_to_find_day(event.props[k])
//   }
//   return rc
// }

 /**
 * Génère une chaîne d'informations détaillées pour un événement donné.
 * Utilise le masque `eventDisplayMask` pour formater le contenu.
 * @param event L'événement pour lequel obtenir les informations.
 * @param format Le format de sortie ('html' ou autre pour texte brut).
 * @returns Une chaîne de caractères formatée avec les informations de l'événement.
 */
export function get_infos(event: CalendarEvent, eventDisplayMask:string = "",format: string = "html"): string | null {
  let formattedString =
    eventDisplayMask.replace("<g>","<strong>").replace("</g>","</strong>")

   // Add start and end times
   const formatterStart=new Intl.DateTimeFormat('fr-FR', {
     month: '2-digit',
     day: '2-digit',
     hour: '2-digit',
     minute: "2-digit"
   })
   const formatterEnd=new Intl.DateTimeFormat('fr-FR', {
     hour: '2-digit',
     minute: "2-digit"
   })

   // Replace placeholders like {property_name} with actual event property values
  formattedString = formattedString.replace(/\{(\w+)\}/g, (match, propName) => {
    if (event.props && event.props[propName] !== undefined) {
      if(typeof event.props[propName] === "string"){
        return event.props[propName];
      }else{
        return event.props[propName].join(",");
      }

    }
    // If the property is not found in event.props, check event itself (e.g., {label})
    if ((event as any)[propName] !== undefined) {
      return (event as any)[propName];
    }
    if(propName.toLowerCase()=="titre" || propName=="label")return event.label
    if(propName.toLowerCase()=="salle")return event.salle
    if(propName.toLowerCase()=="plage")return formatterStart.format(event.startTime)+" -> "+formatterEnd.format(event.endTime)
    if(propName.toLowerCase()=="date")return formatterStart.format(event.startTime)

    return ""
  });


   if (format === "html") {
     return convert_to_find_day(formattedString.replace(/\n/g, "<br>"));
   } else {
     return convert_to_find_day(formattedString.replace(/<strong>/g, "")
       .replace(/<\/strong>/g, "")
       .replace(/\n/g, "\n"));
   }
}

export function extractStyleFromString(style: string): { bgColor: string, textColor: string } {
  if (!style) return { bgColor: 'FFFF00', textColor: '000000' }; // Default yellow with black text
  const bgMatch = style.match(/background-color:\s*([^;]+)/i);
  const colorMatch = style.match(/color:\s*([^;]+)/i);

  let bgColor = 'FFFF00';
  let textColor = '000000';

  if (bgMatch) {
    let color = bgMatch[1].trim();
    if (color === 'green') bgColor = '00FF00';
    else if (color === 'red') bgColor = 'FF0000';
    else if (color === 'blue') bgColor = '0000FF';
    else if (color === 'yellow') bgColor = 'FFFF00';
    else if (color === 'purple') bgColor = '800080';
    else if (color === 'orange') bgColor = 'FFA500';
    else {
      if (color.startsWith('#')) color = color.substring(1);
      if (color.length === 3) {
        color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
      }
      bgColor = color.toUpperCase();
    }
  }

  if (colorMatch) {
    let color = colorMatch[1].trim();
    if (color === 'white') textColor = 'FFFFFF';
    else if (color === 'black') textColor = '000000';
    else if (color === 'green') textColor = '00FF00';
    else if (color === 'red') textColor = 'FF0000';
    else if (color === 'blue') textColor = '0000FF';
    else {
      if (color.startsWith('#')) color = color.substring(1);
      if (color.length === 3) {
        color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
      }
      textColor = color.toUpperCase();
    }
  }

  return { bgColor, textColor };
}


export function filter_values(columnHeaderNames: string[],filter_list:string[]=[]) {
  if(filter_list.length==0 || columnHeaderNames.length==0)return columnHeaderNames

  let rc=[]
  for(let c of columnHeaderNames){
    for(let item of filter_list){
      if(c.toLowerCase().indexOf(item.toLowerCase())!=-1){
        rc.push(c);
        break
      }
    }
  }
  return rc
}

export function string_sorter(to_sort:string[],order="") : string[] {
  let rc=[]
  for(let letter of order.split(",")) {
    for(let elt of to_sort){
      if(elt[0].toLowerCase().startsWith(letter.toLowerCase()))rc.push(elt)
    }
  }
  return rc
}


export function export_to_excel(events: CalendarEvent[], startTime: number, endTime: number, columnHeaderNames: string[]): void {
  import('xlsx').then((XLSX) => {
    // Generate time slots (row headers)
    const timeSlots: string[] = [];
    for (let h = startTime; h <= endTime; h++) {
      const hour = h.toString().padStart(2, '0');
      timeSlots.push(`${hour}:00`);
      if (h < endTime) {
        timeSlots.push(`${hour}:30`);
      }
    }

    // Get the two column properties from columnHeaderNames
    const colProp1 = columnHeaderNames.length > 0 ? columnHeaderNames[0] : null;
    const colProp2 = columnHeaderNames.length > 1 ? columnHeaderNames[1] : null;

    // Get unique values for column headers
    const colValues1 = new Set<string>();
    const colValues2 = new Set<string>();

    for (let event of events) {
      if (colProp1 && event.props[colProp1]) {
        colValues1.add(convert_to_find_day(String(event.props[colProp1])) || String(event.props[colProp1]));
      }
      if (colProp2 && event.props[colProp2]) {
        colValues2.add(convert_to_find_day(String(event.props[colProp2])) || String(event.props[colProp2]));
      }
    }

    const sortedColValues1 = string_sorter_for_column(Array.from(colValues1));
    const sortedColValues2 = string_sorter_for_column(Array.from(colValues2));

    // Build the worksheet data and track styled cells
    const wsData: any[][] = [];
    const styledCells: { row: number, col: number, style: { bgColor: string, textColor: string } }[] = [];
    let currentRow = 1; // Start after header row

    // First row: column headers
    // Cell [0][0] is empty (top-left corner)
    // Row 0 contains the first property values
    const headerRow: any[] = [colProp1 || ''];
    for (let val1 of sortedColValues1) {
      headerRow.push(val1);
    }
    wsData.push(headerRow);

    // For each time slot, create rows with event info
    for (let slot of timeSlots) {
      const row: any[] = [slot];
      let currentCol = 1; // Start after time column

      for (let val1 of sortedColValues1) {
        // Find events that match this time slot and column value
        const matchingEvents = events.filter(event => {
          const eventHour = new Date(event.startTime).getHours();
          const eventMinute = new Date(event.startTime).getMinutes();
          const slotHour = parseInt(slot.split(':')[0]);
          const slotMinute = parseInt(slot.split(':')[1]);

          const eventSlotStr = `${eventHour.toString().padStart(2, '0')}:${eventMinute >= 30 ? '30' : '00'}`;
          const slotStart = `${slotHour.toString().padStart(2, '0')}:${slotMinute.toString().padStart(2, '0')}`;

          const prop1Match = !colProp1 || !event.props[colProp1] ||
            (convert_to_find_day(String(event.props[colProp1])) || String(event.props[colProp1])) === val1;

          return eventSlotStr === slotStart && prop1Match;
        });

        if (matchingEvents.length > 0) {
          // Format event info for the cell
          const eventInfo = matchingEvents.map(e => {
            const time = `${new Date(e.startTime).getHours().toString().padStart(2, '0')}:${new Date(e.startTime).getMinutes().toString().padStart(2, '0')} - ${new Date(e.endTime).getHours().toString().padStart(2, '0')}:${new Date(e.endTime).getMinutes().toString().padStart(2, '0')}`;
            let info = `${e.label}`;
            if (e.salle) info += ` (${e.salle})`;
            if (colProp2 && e.props[colProp2]) info += ` - ${e.props[colProp2]}`;
            info += ` [${time}]`;
            return info;
          }).join('\n');

          row.push(eventInfo);
          // Track this cell for styling
          styledCells.push({
            row: currentRow,
            col: currentCol,
            style: extractStyleFromString(matchingEvents[0].style)
          });
        } else {
          row.push('');
        }
        currentCol++;
      }

      wsData.push(row);
      currentRow++;
    }

    // Create worksheet
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Apply styles to cells
    for (const cell of styledCells) {
      const cellRef = XLSX.utils.encode_cell({ r: cell.row, c: cell.col });
      if (!ws[cellRef]) ws[cellRef] = { t: 's' };
      ws[cellRef].s = {
        fill: {
          patternType: 'solid',
          fgColor: { rgb: cell.style.bgColor }
        },
        font: { color: { rgb: cell.style.textColor } }
      };
    }

    // Set column widths
    ws['!cols'] = [
      { wch: 10 }, // Time column
      ...sortedColValues1.map(() => ({ wch: 30 })) // Data columns
    ];

    // Create workbook and add worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Planning");

    // Generate file and download
    XLSX.writeFile(wb, `planning_export_${new Date().toISOString().slice(0, 10)}.xlsx`);
  }).catch(err => {
    console.error("Erreur lors de l'export Excel:", err);
  });
}

// Log application version from package.json on startup
async function logVersion(): Promise<void> {
  try {
    console.log(`%c PlannerView v${packageJson.version} `, 'background: #1976d2; color: white; font-weight: bold; padding: 4px 8px; border-radius: 4px;');
  } catch (error) {
    console.error('Could not fetch package version:', error);
  }
}

logVersion().then(() => {
  bootstrapApplication(App, appConfig)
    .catch((err) => console.error(err));
});
